<template>
  <BaseTable
      :title="$t('library_topic')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="LibraryTopicListQueryDTO"
      dto-save-list-model="LibraryTopicSaveListCommandDTO"
      store-name="LibraryTopicTable"
      new-item-component="LibraryTopicItem"
      new-item-pass="/LibraryDoc/LibraryTopic/LibraryTopicItem"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
      :modal-dialog="modalDialog"
      :single-select="singleSelect"
      :actionSelected="actionSelected"
      @choice="$emit('choice', $event)"
  >
    <template v-slot:item.name="{ item }">
      <router-link :to="{name:'LibraryTopicItem', params: { itemUid: item.uid}}">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'LibraryTopicTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    singleSelect: {type: [Boolean], default: true},
    actionSelected: {default: false},
  },

  components: {
    BaseTable,
    BaseDeleteIcon,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "search": "Search",
    "No data available": "No data available",
    "deleted": "Deleted",
    "library_topic": "Library topics",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "name": "Name",
      "created_by": "Created by",
      "edited_by": "Edited by",
      "created_by_name": "Created by",
      "edited_by_name": "Edited by",
      "created_on": "Created on",
      "edited_on": "Edited on"
    },
    "Save": "Save",
    "Cancel": "Cancel",
    "New item": "New item"
  },
  "de": {
    "search": "Suche",
    "No data available": "Keine Daten verfügbar",
    "deleted": "Gelöscht",
    "library_topic": "Bibliotheksthemen",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "name": "Name",
      "created_by": "Erstellt von",
      "edited_by": "Bearbeitet von",
      "created_by_name": "Erstellt von",
      "edited_by_name": "Bearbeitet von",
      "created_on": "Erstellt am",
      "edited_on": "Bearbeitet am"
    },
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "New item": "Neuer Artikel"
  }
}
</i18n>
